export const VERDICT_META = {
  exito: { label: 'Éxito', cls: 'on-solid bg-emerald-600 text-white' },
  parcial: { label: 'Parcial', cls: 'bg-amber-300 text-amber-950' },
  fracaso: { label: 'Fracaso', cls: 'on-solid bg-red-600 text-white' },
  rechazada: { label: 'Rechazada', cls: 'on-solid bg-slate-600 text-white' },
  vencida: { label: 'Vencida', cls: 'bg-slate-300 text-slate-800' },
  cancelado: { label: 'Cancelado', cls: 'bg-slate-300 text-slate-800' },
  sin_resultado: { label: 'Sin resultado', cls: 'bg-slate-200 text-slate-700' },
};

export const EVENT_LABELS = {
  project_closed: 'Proyecto cerrado', prediction_measured: 'Predicción medida', proposal_rejected: 'Propuesta rechazada',
  proposal_expired: 'Propuesta vencida', alert_resolved: 'Alerta resuelta', manual: 'Manual',
};

export const STATUS_META = {
  borrador: { label: 'Borrador', plural: 'Borradores', cls: 'border-amber-500 text-amber-700 dark:text-amber-300' },
  aprobada: { label: 'Aprobada', plural: 'Aprobadas', cls: 'border-emerald-500 text-emerald-700 dark:text-emerald-300' },
  archivada: { label: 'Archivada', plural: 'Archivadas', cls: 'border-slate-400 text-slate-500 dark:text-slate-400' },
};

export const SOURCE_LABELS = { ia: 'Redactada por SUPER-100', determinista: 'Texto automático', manual: 'Manual', editada: 'Editada por admin' };
